import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Autoplay } from "swiper/modules";
import { sliderDataWeb } from "../constants/sliderData";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";

const ProjectsWeb = () => {
	return (
		<div
			id="web"
			className="swiper_container_styles"
		>
			<Swiper
				className="swiper_style"
				breakpoints={{
					768: { slidesPerView: 2 },
					1280: { slidesPerView: 3 },
				}}
				autoplay={{ delay: 4000 }}
				loop={true}
				slidesPerView={1}
				spaceBetween={20}
				freeMode={true}
				pagination={{
					clickable: true,
				}}
				modules={[FreeMode, Pagination, Autoplay]}
			>
				{sliderDataWeb.map((item, index) => (
					<SwiperSlide key={index}>
						<Link to={`/projects/${item.id}`}>
							<img
								src={item.backgroundImage}
								alt={item.imgAlt}
								loading="lazy"
							/>
						</Link>
					</SwiperSlide>
				))}
			</Swiper>

			<Link to="/projects">
				<span id="show_more">Show more projects</span>
			</Link>
		</div>
	);
};

export default ProjectsWeb;
